/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { ValuesOf } from '@tmapy/beetlejuice-utils';

/**
 * ```yaml
 * type: string
 * description: |-
 *   * `DEBUG` - Debug
 *   * `INFO` - Info
 *   * `WARNING` - Warning
 *   * `ERROR` - Error
 *   * `CRITICAL` - Critical
 * ```
 */
export const Level02aEnum = {
  DEBUG: 'DEBUG',
  INFO: 'INFO',
  WARNING: 'WARNING',
  ERROR: 'ERROR',
  CRITICAL: 'CRITICAL',
} as const;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type Level02aEnum = ValuesOf<typeof Level02aEnum>;

export type Level02aEnumRequest = Level02aEnum;
export type Level02aEnumResponse = Level02aEnum;
